import axios from 'axios'
import Router from '../routes'
import localforage from 'localforage'
import store from '../store/index'

export default () => {
  axios.interceptors.request.use(request => {
    request.headers.common['Content-Type'] = 'application/json'
    request.headers.common['Accept-Language'] = store.getters['pages/locale']
    request.credentials = 'same-origin'

    return localforage.getItem('authtoken').then((token) => {
      request.headers.common['Authorization'] = token
      return request
    }).catch(() => {
      return request
    })
  })

  axios.interceptors.response.use(undefined, (err) => {
    return new Promise(() => {
      if (err.response.status === 403 || err.response.status === 401) {
        Router.push({ path: '/login' })
      }
      throw err
    })
  })

  return axios
}
